import { render } from "./ODKSettings.vue?vue&type=template&id=751c8804"
import script from "./ODKSettings.vue?vue&type=script&lang=js"
export * from "./ODKSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__